import { defineStore } from 'pinia'
import { ref } from 'vue'
import referenceIndexService from '@/services/referenceIndex.service'

export const useDataStore = defineStore(
    'data',
    () => {
        let isRefreshing = false

        const referenceIndexes = ref([])

        const getReferenceIndexes = async (force = false) => {
            if(force === true || !referenceIndexes.value.length) {
                if(isRefreshing === false) {
                    isRefreshing = true

                    await referenceIndexService.get({
                        fields: 'id,period,irl_index,ilc_index',
                        sort: 'period',
                        desc: 'period',
                    }).then((data) => {
                        referenceIndexes.value = data

                        isRefreshing = false
                    })
                } else {
                    const timeout = (ms) => {
                        return new Promise(resolve => setTimeout(resolve, ms));
                    }
                
                    const whileLoop = async () => {
                        if(isRefreshing === true) {
                            await timeout(100)
                            await whileLoop() 
                        }
                    
                        return false
                    }
                
                    await whileLoop()
                }
            }

            return referenceIndexes.value
        }

        setInterval(() => {
            getReferenceIndexes(true)
        }, 600000)

        return {
            getReferenceIndexes,
        }
    }
)
